import OnboardingRecordSvg from '@/../assets/illustrations/onboarding-record.svg';
import OnboardingRecordJaSvg from '@/../assets/illustrations/onboarding-record.ja.svg';
import { useTranslation } from '@/i18n';

const SVG_NATURAL_WIDTH = 412;
const SVG_NATURAL_HEIGHT = 407;

interface IllustrationProps {
  readonly width: number;
  readonly height: number;
}

export const OnboardingRecordIllustration = ({ width, height }: IllustrationProps) => {
  const { locale } = useTranslation();
  const Svg = locale === 'ja' ? OnboardingRecordJaSvg : OnboardingRecordSvg;
  const scale = Math.min(width / SVG_NATURAL_WIDTH, height / SVG_NATURAL_HEIGHT);
  return (
    <Svg
      height={SVG_NATURAL_HEIGHT * scale}
      testID="onboarding-record-illustration"
      width={SVG_NATURAL_WIDTH * scale}
    />
  );
};
